export default "__VITE_ASSET__IEeeNDPO__"